import styled from 'styled-components';
import { themeGetColor } from '../v2/foundation/theme/themeGet/get.js';

var Container = styled.div.withConfig({
  displayName: "Container",
  componentId: "sc-3ub8d3-0"
})(["overflow-y:auto;position:fixed;top:0;right:0;bottom:0;left:0;width:100vw;height:100vh;height:-webkit-fill-available;background-color:", ";"], themeGetColor('gray.700', 0.3));

export { Container };
